import React from "react";
import {
  List,
  Datagrid,
  TextField,
  EmailField,
  EditButton,
  DeleteButton,
  ReferenceField,
} from "react-admin";
import { CustomEmailField } from "../CustomEmailField";

const TankList = (props) => (
  <List {...props}>
    <Datagrid rowClick="edit">
      <TextField source="name" />
      <TextField source="steps" />
      <TextField source="distance" />
      <TextField source="price" />
      <TextField source="nextTankUpgradeTimes" />
      <ReferenceField label="Tank Before" source="tankBefore" reference="tanks">
        <TextField source="name" />
      </ReferenceField>
      <TextField source="winAMA" label="AMA to win" />
    </Datagrid>
  </List>
);

export default TankList;
